import React from 'react';
import useToggle from '../../hooks/useToggle';
export const withToggle = (Component) => React.forwardRef((props, ref) => {
    const [isToggled, setOn, setOff] = useToggle();
    const withToggleProps = { isToggled, setOn, setOff };
    return React.createElement(Component, { ...props, ...withToggleProps, ref: ref });
});
export default withToggle;
//# sourceMappingURL=index.js.map